const state = () => ({
	phoneNumber: '',
});

export default state;
